import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import * as Icons from "react-feather";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Table,
  ButtonGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import Select from "react-select";
import { useHistory, useParams } from "react-router-dom";
import Axios from "axios";
import { urlAPI, getUser, getToken } from "utility/Common";
import { useDispatch } from "react-redux";
import Center from "react-center";
import Radio from "components/@vuexy/radio/RadioVuexy";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import "assets/scss/plugins/forms/flatpickr/flatpickr.scss";
import NumberInput from "components/NumberInput";
import NumberFormat from "react-number-format";
import Checkbox from "components/@vuexy/checkbox/CheckboxesVuexy";
import PrintComponent from "../component/PrintComponent";
import angkaTerbilang from "@develoka/angka-terbilang-js";
import useDraggableScroll from "use-draggable-scroll";

const initDataState = {
  // id: null,
  id_um: null,
  nomer: null,
  // tglentry: null,
  tglawal: null,
  tglakhir: null,
  unit: null,
  userid: getUser()?.username,
  status: 0,
  noslip: null,
  nominal_permintaan: 0,
  nominal_selisih: 0,
  total_realisasi: 0,
};
const initDetailState = [];

export default function EditPage(props) {
  const { id } = useParams();
  const ref = useRef(null);
  const { onMouseDown } = useDraggableScroll(ref);

  const dispatch = useDispatch();
  const history = useHistory();
  const [dataState, setDataState] = useState(initDataState);
  const [detailState, setDetailState] = useState(initDetailState);

  const [loadingLoad, setLoadingLoad] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);

  const [dataPrint, setDataPrint] = useState(null);
  const [openPrint, setOpenPrint] = useState(false);

  const [selectorAccount, setSelectorAccount] = useState([]);
  const [loadingSelectorAccount, setLoadingSelectorAccount] = useState(false);
  const [selectorKompilator, setSelectorKompilator] = useState([]);
  const [selectorCostCenter, setSelectorCostCenter] = useState([]);
  const [loadingKompilatorDanCC, setLoadingKompilatorDanCC] = useState(false);

  const fetchAccount = () => {
    Axios.get(urlAPI + "/v1/account/selector", {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
      .then((response) => {
        if (response?.data?.result?.rows?.length !== 0) {
          const selectorTemp = response?.data?.result?.rows?.map((obj) => ({
            value: obj?.ACCOUNT,
            label: obj?.ACCOUNT,
            name: obj?.KETERANGAN,
          }));
          setSelectorAccount(selectorTemp);
          setLoadingSelectorAccount(false);
        } else {
          setLoadingSelectorAccount(false);
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: response?.data?.message,
          });
        }
      })
      .catch((err) => {
        setLoadingSelectorAccount(false);
        if (err.response?.statusText === "Unauthorized") {
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
        }
      });
  };

  const fetchDept = () => {
    Axios.get(urlAPI + "/v1/dept/selector", {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
      .then((response) => {
        if (response?.data?.result?.rows?.length !== 0) {
          const tempData = response?.data?.result?.rows;
          const CCTemp = tempData?.map((obj) => ({
            value: obj?.KODE,
            label: obj?.KODE,
            name: obj?.DEPT,
            kompilator: obj?.KOMPILATOR,
          }));
          const KompilatorTemp = tempData
            ?.filter((filter) => filter.KOMPILATOR !== "")
            .map((obj) => ({
              value: obj?.KOMPILATOR,
              label: obj?.KOMPILATOR,
              name: obj?.DEPT,
            }));
          setSelectorCostCenter(CCTemp);
          setSelectorKompilator(KompilatorTemp);
          setLoadingKompilatorDanCC(false);
        } else {
          setSelectorCostCenter([]);
          setSelectorKompilator([]);
          setLoadingKompilatorDanCC(false);
        }
      })
      .catch((err) => {
        setLoadingKompilatorDanCC(false);
        if (err.response?.statusText === "Unauthorized") {
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.dataState?.message,
          });
        }
      });
  };

  const fetchDataForEdit = () => {
    Axios.get(urlAPI + "/v1/uangmuka/dataforedit?id=" + id, {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    })
      .then((response) => {
        console.log("result, ", response?.data?.result);
        if (response?.data?.result?.header.length > 0) {
          const header = response?.data?.result?.header[0];
          setDataState({
            id_um: header?.id_um,
            nomer: header?.nomer,
            tglawal: header?.tglawal,
            tglakhir: header?.tglakhir,
            unit: header?.unit,
            userid: getUser()?.username,
            status: Number(header?.status),
            noslip: header?.noslip,
            nominal_permintaan: Number(header?.nominal_permintaan),
            nominal_selisih: Number(header?.nominal_selisih),
            total_realisasi: Number(header?.total_realisasi),
          });
          const detail = response?.data?.result?.detail;
          const temp = detail?.map((obj) => ({
            id: obj?.id,
            id_header_ptj_um: obj?.id_header_ptj_um,
            unit: obj?.unit,
            kode_rek: obj?.kode_rek,
            keterangan: obj?.keterangan,
            cc: obj?.cc,
            nominal_realisasi: Number(obj?.nominal_realisasi),
          }));
          setDetailState([...temp]);
        } else {
          setDataState({ ...initDataState });
          setDetailState([]);
        }
        setLoadingLoad(false);
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoadingLoad(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoadingLoad(false);
        }
      });
  };

  useEffect(() => {
    setLoadingSelectorAccount(true);
    fetchAccount();
    setLoadingKompilatorDanCC(true);
    fetchDept();
    setLoadingLoad(true);
    fetchDataForEdit();
  }, []);

  // periode undefined = null jangan lupa
  const handleSimpan = (print) => {
    Axios.put(
      urlAPI + "/v1/uangmuka/editPTJ",
      {
        ID: id,
        DATA: dataState,
        DETAIL: detailState,
      },
      {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }
    )
      .then((response) => {
        dispatch({
          type: "FILL_BERHASIL",
          berhasil: true,
          pesan: response.data.message,
        });
        setLoadingSave(false);
        setDataState(initDataState);
        if (print) {
          setDataPrint(response.data.result);
          setOpenPrint(true);
        } else {
          history.push("/keuangan/uang_muka/ptj");
        }
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoadingSave(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.dataState?.message,
          });
          setLoadingSave(false);
        }
      });
  };

  console.log("dataState, ", dataState);
  console.log("detailState, ", detailState);

  return (
    <>
      <PrintComponent
        handleClose={() => {
          setDataPrint(null);
          setOpenPrint(false);
          history.push("/keuangan/uang_muka/ptj");
        }}
        open={openPrint}
        id={dataPrint}
      />
      <Row>
        <Col lg="6" md="6" sm="12">
          <Button
            color="flat-danger"
            // style={{ width: "150px" }}
            onClick={() => {
              history.push("/keuangan/uang_muka/ptj");
            }}
          >
            <Icons.ArrowLeft size={14} /> Kembali
          </Button>
        </Col>
        <Col lg="6" md="6" sm="12">
          <div className="text-right">
            <h1>
              <strong>PTJ Uang Muka: Edit</strong>
            </h1>
          </div>
        </Col>
      </Row>
      <br />
      <Card>
        <CardBody>
          <Row>
            <Col lg="12" md="12" sm="12">
              <FormGroup>
                <Label>Nomor Uang Muka</Label>
                <Input
                  name="nomor"
                  id="nomor"
                  type="text"
                  value={dataState?.nomer}
                  disabled={true}
                />
              </FormGroup>
              <hr />
            </Col>
            <Col lg="6" md="6" sm="12">
              <FormGroup>
                <Label>Periode</Label>
                <Flatpickr
                  value={[dataState?.tglawal, dataState?.tglakhir]}
                  className="form-control"
                  options={{ mode: "range" }}
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <Col lg="6" md="6" sm="12">
              <FormGroup>
                <Label>Unit</Label>
                <Input
                  type="text"
                  name="unit"
                  id="unit"
                  value={dataState?.unit}
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <Col lg="6" md="6" sm="12">
              <FormGroup>
                <Label>Nominal Permintaan</Label>
                <NumberInput
                  name="nominalpermintaan"
                  id="nominalpermintaan"
                  // decimal
                  value={Number(dataState?.nominal_permintaan)}
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <Col lg="6" md="6" sm="12">
              <FormGroup>
                <Label>Nominal Selisih</Label>
                <NumberInput
                  name="nominalselisih"
                  id="nominalselisih"
                  // decimal
                  value={Number(dataState?.nominal_selisih)}
                  disabled={true}
                />
              </FormGroup>
            </Col>
            <Col lg="12" md="12" sm="12">
              <hr />
              {loadingLoad ? (
                <div className="text-center">
                  <h4>
                    <strong>Loading...</strong>
                  </h4>
                </div>
              ) : detailState.length === 0 ? (
                <></>
              ) : (
                <div
                  ref={ref}
                  onMouseDown={onMouseDown}
                  style={{
                    overflowX: "auto",
                    // overflowY: "scroll",
                    width: "100%",
                    maxWidth: "100%",
                    // transform: "rotateX(180deg)",
                  }}
                >
                  <Table
                    bordered
                    hover
                    // responsive
                    style={{
                      border: "1px solid black",
                      width: "100%",
                      maxWidth: "100%",
                      // transform: "rotateX(180deg)",
                    }}
                  >
                    <thead>
                      <tr>
                        <th
                          style={{
                            minWidth: "4px",
                          }}
                        >
                          <p className="text-center">
                            <strong>Opsi</strong>
                          </p>
                        </th>
                        <th
                          style={{
                            minWidth: "300px",
                          }}
                        >
                          <p className="text-center">
                            <strong>URAIAN</strong>
                          </p>
                        </th>
                        <th
                          style={{
                            minWidth: "150px",
                          }}
                        >
                          <p className="text-center">
                            <strong>ACC</strong>
                          </p>
                        </th>
                        <th
                          style={{
                            minWidth: "180px",
                          }}
                        >
                          <p className="text-center">
                            <strong>CC</strong>
                          </p>
                        </th>
                        <th
                          style={{
                            minWidth: "200px",
                          }}
                        >
                          <p className="text-center">
                            <strong>Realisasi</strong>
                          </p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailState?.map((obj, idx) => (
                        <tr>
                          <td>
                            {!obj?.id && (
                              <Button
                                color="danger"
                                block={true}
                                size="sm"
                                onClick={() => {
                                  let tempDetail = detailState;
                                  tempDetail.splice(idx, 1);
                                  setDataState({
                                    ...dataState,
                                    nominal_selisih:
                                      Number(dataState?.nominal_permintaan) -
                                      tempDetail.reduce(function (prev, cur) {
                                        return (
                                          Number(prev) +
                                          Number(cur.nominal_realisasi)
                                        );
                                      }, 0),
                                    total_realisasi: tempDetail.reduce(
                                      function (prev, cur) {
                                        return (
                                          Number(prev) +
                                          Number(cur.nominal_realisasi)
                                        );
                                      },
                                      0
                                    ),
                                  });
                                  setDetailState([...tempDetail]);
                                }}
                              >
                                <Icons.Trash size={18} />
                              </Button>
                            )}
                          </td>
                          <td>
                            {idx === 0 ? (
                              <p className="text-left">{obj?.keterangan}</p>
                            ) : (
                              <Input
                                id="keterangan"
                                name="keterangan"
                                type="text"
                                value={obj?.keterangan}
                                onChange={(e) => {
                                  let tempDetail = detailState;
                                  tempDetail[idx] = {
                                    ...tempDetail[idx],
                                    keterangan: e?.target.value,
                                  };
                                  setDetailState([...tempDetail]);
                                }}
                              />
                            )}
                          </td>
                          <td>
                            <Select
                              styles={{
                                color: "black",
                              }}
                              id="acc"
                              name="acc"
                              isLoading={loadingSelectorAccount}
                              options={selectorAccount}
                              value={
                                selectorAccount.find(
                                  (find) => find.value === obj?.kode_rek
                                ) ?? null
                              }
                              isClearable={true}
                              onChange={(e) => {
                                let tempObj = detailState;
                                tempObj[idx] = {
                                  ...tempObj[idx],
                                  kode_rek: e?.value ?? null,
                                };
                                setDetailState([...tempObj]);
                              }}
                            />
                          </td>
                          <td>
                            <Select
                              styles={{
                                color: "black",
                              }}
                              id="acc"
                              name="acc"
                              isLoading={loadingKompilatorDanCC}
                              options={selectorCostCenter}
                              value={
                                selectorCostCenter.find(
                                  (find) => find.value === obj?.cc
                                ) ?? null
                              }
                              isClearable={true}
                              onChange={(e) => {
                                let tempObj = detailState;
                                tempObj[idx] = {
                                  ...tempObj[idx],
                                  cc: e?.value ?? null,
                                };
                                setDetailState([...tempObj]);
                              }}
                            />
                          </td>
                          <td>
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>Rp.</InputGroupText>
                              </InputGroupAddon>
                              <NumberInput
                                name="nominal_realisasi"
                                id="nominal_realisasi"
                                // decimal
                                value={Number(obj?.nominal_realisasi)}
                                onChange={(e) => {
                                  let tempDetail = detailState;
                                  tempDetail[idx] = {
                                    ...tempDetail[idx],
                                    nominal_realisasi: Number(e?.target.value),
                                  };
                                  setDataState({
                                    ...dataState,
                                    nominal_selisih:
                                      Number(dataState?.nominal_permintaan) -
                                      tempDetail.reduce(function (prev, cur) {
                                        return (
                                          Number(prev) +
                                          Number(cur.nominal_realisasi)
                                        );
                                      }, 0),
                                    total_realisasi: tempDetail.reduce(
                                      function (prev, cur) {
                                        return (
                                          Number(prev) +
                                          Number(cur.nominal_realisasi)
                                        );
                                      },
                                      0
                                    ),
                                  });
                                  setDetailState([...tempDetail]);
                                }}
                              />
                            </InputGroup>
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan="6">
                          <Button
                            color="primary"
                            size="sm"
                            onClick={() => {
                              let tempDetail = detailState;
                              tempDetail.push({
                                id: null,
                                unit: dataState?.unit,
                                kode_rek: null,
                                keterangan: "",
                                cc: null,
                                nominal_realisasi: 0,
                              });
                              setDetailState([...tempDetail]);
                            }}
                          >
                            <Icons.Plus size={18} /> Tambah Baris
                          </Button>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p className="text-center"></p>
                        </td>
                        <td>
                          <p className="text-left">
                            <strong>Total</strong>
                          </p>
                        </td>
                        <td>
                          <p className="text-center"></p>
                        </td>
                        <td>
                          <p className="text-center"></p>
                        </td>
                        <td>
                          <p className="text-right">
                            <strong>
                              {"Rp. "}
                              <NumberFormat
                                value={detailState.reduce(function (prev, cur) {
                                  return (
                                    Number(prev) + Number(cur.nominal_realisasi)
                                  );
                                }, 0)}
                                displayType={"text"}
                                decimalSeparator={","}
                                thousandSeparator={"."}
                                decimalScale={0}
                                fixedDecimalScale={true}
                              />
                            </strong>
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              )}
            </Col>
          </Row>
          <br />
          <br />
          <br />
          <br />
          <ButtonGroup className="float-right">
            <Button
              color="primary"
              onClick={() => {
                setLoadingSave(true);
                handleSimpan(false);
              }}
              disabled={
                !id ||
                loadingSave ||
                detailState.length < 1 ||
                detailState.reduce(function (prev, cur) {
                  return Number(prev) + Number(cur.nominal_realisasi);
                }, 0) < 1
              }
            >
              {loadingSave ? "Loading..." : "Simpan"}
            </Button>
            &nbsp;
            <Button
              color="success"
              onClick={() => {
                setLoadingSave(true);
                handleSimpan(true);
              }}
              disabled={
                !id ||
                loadingSave ||
                detailState.length < 1 ||
                detailState.reduce(function (prev, cur) {
                  return Number(prev) + Number(cur.nominal_realisasi);
                }, 0) < 1
              }
            >
              {loadingSave ? "Loading..." : "Simpan & Print"}
            </Button>
          </ButtonGroup>
        </CardBody>
      </Card>
    </>
  );
}
